import { createTheme } from '@mui/material/styles';
export default createTheme({
  palette: { mode: 'dark', primary: { main: '#EEF272', contrastText: '#131313' }, background: { default: '#000000', paper: '#131313' }, text: { primary: '#FEFDEE', secondary: '#aaa99d' }, divider: '#ffffff24' },
  typography: { fontFamily: 'Arial, Helvetica, sans-serif', h1: { fontFamily: 'NUUN Display, sans-serif' }, h2: { fontFamily: 'NUUN Display, sans-serif' }, h3: { fontFamily: 'NUUN Display, sans-serif' }, h4: { fontFamily: 'NUUN Display, sans-serif' }, h5: { fontFamily: 'NUUN Display, sans-serif' }, h6: { fontFamily: 'NUUN Display, sans-serif' } },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: { styleOverrides: { root: { fontWeight: 700, borderRadius: 12 } } },
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
    MuiOutlinedInput: { styleOverrides: { root: { backgroundColor: '#202020' } } },
  },
});
